import styled from "styled-components";

export const StyledPaymentButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;

    & > div {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .button {
        width: 100%;
        height: 50px;
        border-radius: 7px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        box-sizing: content-box;
        cursor: pointer;
        background-color: black;

        &.paypal {
            background-color: #ffc439;
        }

        img {
            height: 24px;
        }
    }

    .paypal-container {
        position: relative;
        height: 50px;
        overflow: hidden;
        border-radius: 7px;

        & > div {
            position: absolute;
            top: 0;
            left: 0;
            margin: 0 !important;
        }
    }
` as any;
